export const DEFAULT_UNICO_CAPTURE_MAX_ATTEMPTS = 3;

export const normalizeUnicoCaptureMaxAttempts = (
  value: unknown,
  fallback = DEFAULT_UNICO_CAPTURE_MAX_ATTEMPTS
): number => {
  const parsed = Number(value);

  if (!Number.isFinite(parsed)) {
    return fallback;
  }

  const normalized = Math.floor(parsed);

  return normalized >= 1 ? normalized : fallback;
};
